// Generated by purs version 0.15.16
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
var liftWidgetWidget = {
    liftWidget: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var liftWidget = function (dict) {
    return dict.liftWidget;
};
var liftWidget1 = function (dictMonad) {
    return function (dictMonadTrans) {
        var lift = Control_Monad_Trans_Class.lift(dictMonadTrans)(dictMonad);
        return function (dictLiftWidget) {
            return {
                liftWidget: (function () {
                    var $11 = liftWidget(dictLiftWidget);
                    return function ($12) {
                        return lift($11($12));
                    };
                })()
            };
        };
    };
};
export {
    liftWidget,
    liftWidgetWidget,
    liftWidget1
};
//# sourceMappingURL=index.js.map
